const ITEMS = [
    "Branding",
    "Graphic Design",
    "Social Media",
    "Marketing",
    "Web Design",
    "Content",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden bg-[#0C0C0C] border-y border-[#C9DDEE]/15 py-5 md:py-6 -rotate-1 scale-[1.02] my-4"
            aria-hidden="true"
        >
            <div className="marquee-track flex w-max items-center gap-10 pr-10">
                {[...row, ...row].map((item, i) => (
                    <span key={i} className="flex items-center gap-10">
                        <span className="font-serif-ed italic text-2xl md:text-3xl text-[#F1F1EF]/80 whitespace-nowrap">
                            {item}
                        </span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
                                fill={i % 2 === 0 ? "#D3A0A7" : "#A9C6DE"}
                            />
                        </svg>
                    </span>
                ))}
            </div>
        </div>
    );
};
